<template lang="pug">
  include ../mixins
  validation-observer(
    tag="form"
    ref="observer"
    v-slot="{ errors }"
    @submit.prevent="validateBeforeSubmit"
  )
    news-subscription-form-controller(
      :formdata="formdata"
      @handle-response="handleSubmit($event)"
    )
      template(#default="{ categoriesList, send, isLoad, handleSelection, checkCurrentOption }")
        row(align="end" space="sm-xl")
          cell(cols="12 6-md auto-lg")
            +b.form.ma--bottom_sm-till-lg
              control-input(
                rules="custom_email|required"
                type="email"
                label-class="form__label"
                class-name="form__input"
                :input-label="_('E-mail')"
                v-model="formdata.email"
                :required="true"
                name="email"
              )
          cell(cols="12 6-md auto-lg")
            +b.common-multiselect--fullwidth.form.ma--bottom_sm-till-lg
              control-multiselect(
                :options="categoriesList"
                track-by="id"
                label="title"
                :allow-empty="true"
                label-class="form__label"
                :input-label="_('Тема')"
                v-model="formdata.category"
                :placeholder="_('Выберите тему')"
                :required="false"
                @input="handleSelection($event)"
                @select="checkCurrentOption($event)"
                :multiple="true"
                name="category"
              )
          cell(cols="12 narrow-lg")
            +e.button.de-text--size_2xs.ma--bottom_sm-till-lg.BEM-BUTTON(
              appearance="fill-accent-1"
              space="sm"
              rounded="sm"
              width="md"
              :disable="isLoad"
              @event="validateBeforeSubmit(send)"
            ) {{_('Подписаться')}}
</template>

<script>
import FormMixin from '@mixins/form.mixin.js'

export default {
  name: 'news-subscription-form-page',
  mixins: [FormMixin],
  components: {
    'news-subscription-form-controller': () => import('./NewsSubscriptionController.vue'),
  },
  data() {
    return {
      formdata: {
        email: '',
        category: null,
      },
    }
  },
  methods: {
    handleSubmit(res) {
      this.handleResponse({ modal: true, res })
    },
  },
}
</script>
